<script setup>
import ModuleListItem from '@/Pages/area6audio/moduleListItem.vue';
import {compClass} from '@/libraries/utils.js'
import {getCurrentInstance, onMounted} from 'vue';
import CustomScrollbar from 'custom-vue-scrollbar'
import 'custom-vue-scrollbar/dist/style.css'
import $ from 'jquery'
import MicroModal from 'micromodal';
import {usePage} from '@inertiajs/vue3';
import moment from 'moment/moment';
import WavyTitle from '../sharedComponents/wavyTitle.vue';
import {useArea6audioStateStore} from '@/stores/area6audioState.js';

const instance = getCurrentInstance()

const areaStore = useArea6audioStateStore()
// console.debug(areaStore.modules)

onMounted(()=>{
	const safetyOffset = 50
	$('.scrollbar__scroller').height(window.innerHeight - safetyOffset)
})

MicroModal.init()

const user = usePage().props.user
const childBirthdate = moment(user?.child_birthdate)
</script>

<template>
	<CustomScrollbar :thumb-max-size="500">
		<div class="pt-4 pl-2 pr-8 h-full flex flex-col bg-white" :class="compClass(instance)">
			<div class="pb-14">
				<div class="pl-8">
					<WavyTitle :text="$tg('area6audio.title')" class="py-8 font-poppins text-6xl font-bold text-fuchsia uppercase text-center"/>
					<article
						class="pb-8"
						v-html="$tg('area6audio.description')"
					/>
				</div>
				<div class="basis-full">
					<div v-for="(module, mIndex) in areaStore.modules" :key="mIndex" class="mb-8">
						<moduleListItem
							:module="module"
							:childBirthdate="childBirthdate"
						/>
					</div>
				</div>
			</div>
		</div>
	</CustomScrollbar>
</template>
